export type ApiError = {
  error: {
    data: string[];
    message: string;
  };
};
